const bundleItems = document.querySelectorAll('h3.bundle-item-title');

bundleItems.forEach(item => {
  if (item.textContent.includes("Wild Alaska King Salmon")) {
    item.textContent = "Wild Pacific King Salmon";
  }
});



setInterval(() => {
  const sidebarTitles = document.querySelectorAll('span.bundles-chosen-item-title');
  
  sidebarTitles.forEach(item => {
    if (item.textContent.includes("Wild Alaska King Salmon")) {
      item.textContent = "Wild Pacific King Salmon";
    }
  });
}, 300);
